import '@/common/App.css';

import { LobbyPage } from '@/hoster/routes/LobbyPage';
import { installActiveHostRefreshGuard } from '@/common/utils/activeHostRefreshGuard';

import { Toast } from '@/common/components/base/Toast';
import * as RadixToast from '@radix-ui/react-toast';
import { absolute } from '@toilet-paper-games/ui';
import { observer, Observer } from 'mobx-react-lite';
import { CornerBadge } from './components/CornerBadge';
import {
  HosterAppModel,
  hosterAppModelContext,
  ScreenState,
} from './models/HosterAppModel';
import { GamePlayerPage } from './routes/GamePlayerPage';

// I don't like doing this as it exposes the package.json to the client
import { setupAutoScreenLock } from '@/common/utils/browser';
import packageJson from '../../package.json';
import { Footer } from './components/Footer';
import { SettingDialog } from './components/dialogs/SettingsDialog';
import { FooterInfo } from '@/common/components/FooterInfo';
import { useEffect } from 'react';

setupAutoScreenLock();

export const hosterAppModel = new HosterAppModel();
window.hosterAppModel = hosterAppModel;

export const App = observer(() => {
  useEffect(
    () =>
      installActiveHostRefreshGuard({
        hasConnectedPlayers: () =>
          hosterAppModel.networkHandler.userManager.connectedUsers.length > 0,
      }),
    [],
  );

  if (!window.hosterAppModel) {
    window.hosterAppModel = hosterAppModel;
  }

  return (
    <hosterAppModelContext.Provider value={window.hosterAppModel}>
      <RadixToast.Provider>
        <ScreenDisplay />
        <Dialogs />
        {/* {hosterAppModel.networkHandler.userManager.connectedUsers.length === 0 && (
          <Footer />
        )} */}
        <div css={[absolute(0, 0, 0, 0), { zIndex: 10000, pointerEvents: 'none' }]}>
          {/* // TODO: This should be controlled by an env variable but for now, it will be a persistent badge */}
          <CornerBadge>BETA {packageJson.version}</CornerBadge>
        </div>
        <FooterInfo />
        <Observer>
          {() => (
            <>
              {hosterAppModel.toastManager.toasts.map((toastData) => (
                <Toast key={toastData.id} {...toastData.toast} />
              ))}
            </>
          )}
        </Observer>
        <RadixToast.Viewport
          css={{
            '--viewport-padding': '25px',
            position: 'fixed',
            bottom: '0',
            right: '0',
            display: 'flex',
            flexDirection: 'column',
            padding: 'var(--viewport-padding)',
            gap: '10px',
            width: '390px',
            maxWidth: '100vw',
            margin: '0',
            listStyle: 'none',
            zIndex: 2147483647,
            outline: 'none',
          }}
        />
      </RadixToast.Provider>
    </hosterAppModelContext.Provider>
  );
});

export const ScreenDisplay = observer(() => {
  const appStore = hosterAppModel;

  const screenState = appStore.screenState;

  switch (screenState) {
    case ScreenState.LOBBY:
      return <LobbyPage />;
    case ScreenState.GAME:
      return <GamePlayerPage />;
    default:
      return <div>Unknown screen state</div>;
  }
});

export const Dialogs = observer(() => {
  return [<SettingDialog />];
});
